module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./node_modules/websocket/lib/version.js
// module id = 151
// module chunks = 0